/** A count read at a glance. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./MetricTile.css";

export interface MetricTileProps {
  readonly value: ReactNode;
  readonly label: ReactNode;
  readonly hint?: ReactNode;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function MetricTile({ value, label, hint, className, style }: MetricTileProps) {
  return (
    <div className={cn("al-metric", className)} style={style}>
      <div className="al-metric-value al-tabular">{value}</div>
      <div className="al-metric-label">{label}</div>
      {hint !== undefined ? <div className="al-metric-hint">{hint}</div> : null}
    </div>
  );
}
